import React from 'react'
import StudentResult1 from './StudentResult1'
import StudentResult2 from './StudentResult2'

const StudentResult = ({id}) => {
  return (
    <div>
      <StudentResult1
      id={id}
      />
  
    </div>
  )
}

export default StudentResult
